import { computed, Injectable, signal, WritableSignal } from '@angular/core';
import { IPageDetails } from '../data/page-details';
import { FormTypes } from '../constants/form-types.constants';
import { ApplicantText } from '../models/applicant-text';

enum ApplicantType {
  applicant,
  otherApplicant,
  worker,
  employee
}


const ApplicantTranslationText: Map<ApplicantType, ApplicantText> = new Map([
  [ApplicantType.applicant, { your: "Your", areYou: "Are you", you: "You", doYou: "Do you", haveYou: "Have you", youHave: "You have" }],
  [ApplicantType.otherApplicant, { your: "Applicant's", areYou: "Is the applicant", you: "The applicant", doYou: "Does the applicant", haveYou: "Has the applicant", youHave: "The applicant has" }],
  [ApplicantType.worker, { your: 'The Worker\'s', areYou: 'Is the Worker', you: 'The Worker', doYou: 'Does the Worker', haveYou: 'Has the Worker', youHave: 'The Worker has' }],
  [ApplicantType.employee, { your: "The Employee's", areYou: "Is the Employee", you: "The Employee", doYou: "Does the Employee", haveYou: "Has the Employee", youHave: "The Employee has" }]
]);

@Injectable({
  providedIn: 'root'
})
export class AssessmentService {

constructor() { }

  selectedForm = signal<IPageDetails | null>(null);  

  isFormType = (formType: string) => computed(() => {
    var selectedForm = this.selectedForm();
    return selectedForm?.id === formType ||
    selectedForm?.id?.includes(formType)
    || false; // failback to false to guarentee boolean
  });

    isBusiness = computed(() => this.isFormType(FormTypes.BUSINESS)());
    isChild = computed(() => this.isFormType(FormTypes.CHILD)());
    isParent = computed(() => this.isFormType(FormTypes.PARENT)());
    isPartner = computed(() => this.isFormType(FormTypes.PARTNER)());
    isSkilled = computed(() => this.isFormType(FormTypes.SKILLED)());
    isStudy = computed(() => this.isFormType(FormTypes.STUDY)());
    isWork = computed(() => this.isFormType(FormTypes.WORK)());
    isVisit = computed(() => this.isFormType(FormTypes.VISIT)());
    isEmployerTemp = computed(() => this.isFormType(FormTypes.EMPLOYER_TEMP)());
    isEmployerPerm = computed(() => this.isFormType(FormTypes.EMPLOYER_PERM)());
    isGeneric = computed(() => this.isFormType(FormTypes.GENERIC)());
    isBusinessEnquiry = computed(() => this.isFormType(FormTypes.BUSINESS_ENQUIRY)());
    isAppealRefuse = computed(() => this.isFormType(FormTypes.APPEAL_REFUSE)());
    isAppealCancel = computed(() => this.isFormType(FormTypes.APPEAL_CANCEL)());
    isGeneral = computed(() => this.isFormType(FormTypes.GENERAL)());
    isVevo = computed(() => this.isFormType(FormTypes.VEVO)());
    isVevoMyself = computed(() => this.isFormType(FormTypes.VEVO_MYSELF)());
    isVevoEmployee = computed(() => this.isFormType(FormTypes.VEVO_EMPLOYEE)());
    isVevoContract = computed(() => this.isFormType(FormTypes.VEVO_CONTRACT)());



  /**
   * Translation context for the current form
   * Used to provide dynamic labels in the UI
   * depending on the perspective of the user
   */
  applicantType = computed(() => {
    const form = this.selectedForm();
    
    if (!form) // Fail to otherApplicant if no form selected somehow
      return ApplicantType.otherApplicant;

    if(this.isFormType(FormTypes.VEVO_CONTRACT)())
      return ApplicantType.worker;

    if(this.isFormType(FormTypes.VEVO_EMPLOYEE)())
      return ApplicantType.employee;
    
    // Default to applicant
    return ApplicantType.applicant;
  });

  applicantText = computed(() =>
    ApplicantTranslationText.get(this.applicantType())!
  );
}
